import * as RAvatar from "@radix-ui/react-avatar";
import { cn } from "@/lib/cn";

interface AvatarProps {
  initials?: string;
  src?: string;
  alt?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZES = {
  sm: "h-8 w-8 text-xs",
  md: "h-9 w-9 text-sm",
  lg: "h-12 w-12 text-base",
} as const;

export function Avatar({ initials, src, alt, size = "md", className }: AvatarProps) {
  return (
    <RAvatar.Root className={cn("inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-brand-gradient text-white font-semibold", SIZES[size], className)}>
      {src && <RAvatar.Image src={src} alt={alt || ""} className="h-full w-full object-cover" />}
      <RAvatar.Fallback delayMs={300}>{initials || "?"}</RAvatar.Fallback>
    </RAvatar.Root>
  );
}
